import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import Dropdown from "src/components/Dropdown";
import SvgContainer from "src/components/SvgContainer";
import ScrollBox from "src/atoms/ScrollBox";
import { ReactComponent as DownArrowIcon } from "./down-arrow.svg";

export default class Select extends React.Component {
  state = {
    isOpen: false
  };

  openSelect = () => this.setState({ isOpen: true });
  closeSelect = () => this.setState({ isOpen: false });

  render() {
    const { isOpen } = this.state;
    const { selectedItem, root, items } = this.props;
    return (
      <>
        <Dropdown
          isOpen={isOpen}
          onClose={this.closeSelect}
          anchorEl={
            <Flex
              alignItems="center"
              onClick={this.openSelect}
              p="6px 12px"
              borderRadius="24px"
              border="solid 1px"
              borderColor="outline"
              _hover={{
                borderColor: "outlineHover"
              }}
              {...root}
            >
              {selectedItem}
              <SvgContainer
                ml="2px"
                icon={DownArrowIcon}
                fill="mediumEmphasis"
              />
            </Flex>
          }

          // PaperProps={{
          //   style: {
          //     // background: theme.colors.surfaceElevated2,
          //     width: items.length > 9 ? "164px" : "148px",
          //     borderRadius: "12px",
          //     margin: "0 auto",
          //     boxShadow:
          //       "0 2px 4px -1px rgba(0, 0, 0, 0.12), 0 1px 16px 0 rgba(0, 0, 0, 0.06), 0 4px 8px 0 rgba(0, 0, 0, 0.08)"
          //   }
          // }}
        >
          <ScrollBox px="16px" mt="16px" mb="6px" maxHeight="150px">
            <Flex flexWrap="wrap" width="116px" mb="-10px">
              {items.map((item, id) => (
                <Box key={id} pb="10px" pr={(id + 1) % 3 === 0 ? 0 : "10px"}>
                  {item}
                </Box>
              ))}
            </Flex>
          </ScrollBox>
        </Dropdown>
      </>
    );
  }
}
